import { mapGetters, mapState } from 'vuex'

export default {
	computed: {
		...mapGetters({
			getLocalizationByKey: 'Api/Localizations/getLocalizationByKey'
		}),
    ...mapState({
      _lang: state => state.Api.Localizations.language,
    }),
	},
	methods: {
		_(key) {
			return this.getLocalizationByKey(key)
		},
		sprintf(formatString, content) {
			return formatString.replace('%s', content)
		},
    translateConverter(converter) {
      if (!converter) {
        return this._('N/A')
      }
      
      const fallbackName = converter.name_en ?? converter.description ?? this._('N/A')
      
      switch (this._lang) {
        case 'de':
          return converter.name_de ?? fallbackName
        case 'it':
          return converter.name_it ?? fallbackName
        case 'fr':
          return converter.name_fr ?? fallbackName
        case 'es':
          return converter.name_es ?? fallbackName
        default:
          return fallbackName
      }
    },
    translateRegion(region) {
      if (!region) {
        return this._('N/A')
      }
      
      const fallbackName = region.name_english ?? this._('N/A')
      
      switch (this._lang) {
        case 'de':
          return region.name_german ?? fallbackName
        case 'it':
          return region.name_it ?? fallbackName
        case 'fr':
          return region.name_fr ?? fallbackName
        case 'es':
          return region.name_es ?? fallbackName
        default:
          return fallbackName
      }
    },
    translateEngine(engine) {
      if (!engine) {
        return this._('N/A')
      }
      
      const fallbackName = engine.name_english ?? this._('N/A')
      
      switch (this._lang) {
        case 'de':
          return engine.name_german ?? fallbackName
        case 'it':
          return engine.name_it ?? fallbackName
        case 'fr':
          return engine.name_fr ?? fallbackName
        case 'es':
          return engine.name_es ?? fallbackName
        default:
          return fallbackName
      }
    },
    translateMaterial(material) {
      if (!material) {
        return this._('N/A')
      }
      
      const fallbackName = material.name_english ?? this._('N/A')
      
      switch (this._lang) {
        case 'de':
          return material.name_german ?? fallbackName
        case 'it':
          return material.name_it ?? fallbackName
        case 'fr':
          return material.name_fr ?? fallbackName
        case 'es':
          return material.name_es ?? fallbackName
        default:
          return fallbackName
      }
    },
    translateBrand(brand) {
      if (!brand) {
        return this._('N/A')
      }
      
      const fallbackName = brand.name_en ?? brand.name ?? this._('N/A')
      
      switch (this._lang) {
        case 'de':
          return brand.name_de ?? fallbackName
        case 'it':
          return brand.name_it ?? fallbackName
        case 'fr':
          return brand.name_fr ?? fallbackName
        case 'es':
          return brand.name_es ?? fallbackName
        default:
          return fallbackName
      }
    },
    translateBusinessCase(businessCase) {
      if (!businessCase) {
        return this._('N/A')
      }
      
      const fallbackName = businessCase.name_english ?? this._('N/A')
      
      switch (this._lang) {
        case 'de':
          return businessCase.name_german ?? fallbackName
        case 'it':
          return businessCase.name_it ?? fallbackName
        case 'fr':
          return businessCase.name_fr ?? fallbackName
        case 'es':
          return businessCase.name_es ?? fallbackName
        default:
          return fallbackName
      }
    },
    translateInscription(inscription) {
      if (!inscription) {
        return this._('N/A')
      }
      
      const fallbackName = inscription.inscription_en ?? inscription.inscription ?? this._('N/A')
      
      switch (this._lang) {
        case 'de':
          return inscription.inscription_de ?? fallbackName
        case 'it':
          return inscription.inscription_it ?? fallbackName
        case 'fr':
          return inscription.inscription_fr ?? fallbackName
        case 'es':
          return inscription.inscription_es ?? fallbackName
        default:
          return fallbackName
      }
    },
    translateEntity(type, entity) {
      if (!entity) {
        return this._('N/A')
      }
      
      switch (type) {
        case 'converters': case 'converter':
          return this.translateConverter(entity)
        case 'regions': case 'region':
          return this.translateRegion(entity)
        case 'business_cases': case 'business_case':
          return this.translateBusinessCase(entity)
        case 'engines': case 'engine':
          return this.translateEngine(entity)
        case 'brands': case 'brand':
          return this.translateBrand(entity)
        case 'materials': case 'material':
          return this.translateBrand(entity)
        case 'inscriptions': case 'inscription':
          return this.translateInscription(entity)
        case 'currency': case 'currencys': case 'currencies':
          return this._(entity.code)
      }
    },
	}
}
